import Field from "@/components/form/Field.tsx";
import {Label} from "@/components/ui/label.tsx";
import {
    Select,
    SelectItem,
    SelectTrigger,
    SelectValue,
    SelectContent
} from "@/components/ui/select.tsx"
import {cn} from "@/lib/utils.ts";
import { NumericFormat } from 'react-number-format';


export default function CurrencyField(
    {name, label, defaultValue, validate, className, onBlur}: {
        name: string,
        label: string,
        defaultValue?: Currency,
        validate?: (value: any) => {label: string, text: string} | undefined,
        className?: string,
        onBlur?: (val: any) => void
    }
) {
    const classes = "grow w-full" + (className ?? "")

    return (
        <Field name={name} defaultValue={defaultValue ?? {valuta: "HUF"}} validate={validate}>
            {
                (field) => {
                    return (
                        <>
                            <Label aria-invalid={field.error ? "true" : "false"} className={classes}>{label}
                                <div className={"flex gap-1"}>
                                    <NumericFormat
                                        aria-invalid={field.error ? "true" : "false"}
                                        className={cn(
                                            "border-input file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground flex h-9 w-full min-w-0 rounded-md border bg-white px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
                                            "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
                                            "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
                                            className
                                        )}
                                        onValueChange={(numberFormatValue) => {
                                            field.onChange({
                                                ...field.value,
                                                value: numberFormatValue.floatValue
                                            })
                                        }}
                                        value={field.value?.value}
                                        onBlur={()=> {
                                            field.onBlur()
                                            onBlur?.(field.value)
                                        }}
                                        thousandSeparator={" "}
                                    />
                                    <Select value={field.value?.valuta} onValueChange={(valuta) => {
                                        field.onChange({
                                            ...field.value,
                                            valuta: valuta
                                        })
                                        field.onBlur()
                                        onBlur?.({
                                            ...field.value,
                                            valuta: valuta
                                        })
                                    }}>
                                        <SelectTrigger className="w-16">
                                            <SelectValue placeholder="Ft"/>
                                        </SelectTrigger>
                                        <SelectContent className="w-14">
                                           <SelectItem className={"w-14"} value="HUF">Ft</SelectItem>
                                            <SelectItem className={"w-14"} value="EUR">€</SelectItem>
                                        </SelectContent>
                                    </Select>
                                </div>
                                <div className={"h-4"}>
                                    <span className={"text-destructive text-sm"}>{field.error ? field.error.text : ""}</span>
                                </div>
                            </Label>


                        </>)
                }
            }
        </Field>
    )
}